const config = {
    S3Bucket: 'storage-bhavins',
    region: 'us-east-1'
}

export default config;